import EditIcon from "@mui/icons-material/Edit";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useMutation } from "@tanstack/react-query";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { PropDisplay } from "../../../../components/PropDisplay";
import { generateOrcamentoPdf } from "../../../../services/api.service";
import { IObra, IPeca } from "../../../Obras/newObra/IObra";
import { IOrcamento } from "../IOrcamento";

export default function OrcamentosDisplay({ orcamento, setEditing }: { orcamento: IOrcamento; setEditing: Dispatch<SetStateAction<boolean>> }) {
	const navigate = useNavigate();
	const mutation = useMutation(() => generateOrcamentoPdf(orcamento.id.toString()), {
		onSuccess: () => console.log("Tudo tass"),
		onError: (e) => console.log("Ta fdd: ", e),
	});

	return (
		<>
			<div className="border rounded-md shadow-md p-8 px-16 text-sm m-10">
				<h2 className="font-bold text-xl mb-4">Orçamento {orcamento.billCode}</h2>

				<PropDisplay prop={"Cliente"} value={orcamento.client?.name} />

				<PropDisplay prop={"Nº Orçamento"} value={orcamento.billCode} />

				<PropDisplay prop={"Data"} value={orcamento.date} />

				<PropDisplay prop={"Validade"} value={orcamento.validade} />

				<PropDisplay prop={"Importância"} value={orcamento.importancia ?? ""} />

				<PropDisplay prop={"Observaçoes"} value={orcamento.observacoes ?? ""} />

				<PropDisplay prop={"V/Requisição"} value={orcamento.vossaRequisicao ?? ""} />

				<PropDisplay prop={"Valor s/ IVA"} value={`${orcamento.valueWithoutIVA?.toString()} €`} />

				<PropDisplay prop={"Valor c/ IVA"} value={orcamento.valueWithIVA ? `${orcamento.valueWithIVA?.toString()} €` : ""} />

				<PropDisplay prop={"Descartar IVA"} value={orcamento.discardIVA ? "Sim" : "Não"} />

				<PropDisplay prop={"Aceite"} value={orcamento.accepted ? "Sim" : "Não"} />

				<PropDisplay prop={"Obras"} value={orcamento.obras?.map((o: Partial<IObra>) => o.number).join(" ,")} />

				<PropDisplay prop={"Peças"} value={orcamento.pecasOrcamentadas?.map((o: Partial<IPeca>) => o.reference).join(" ,")} />

				{orcamento.pedidoOrcamento ? (
					<div className="flex justify-between items-center py-2">
						<div className="font-bold">Pedido de orçamento:</div>
						<div onClick={() => navigate(`/pedidos-orcamento/${orcamento?.pedidoOrcamento?.id}`)} className="text-cyan-600 hover:underline bold cursor-pointer">
							{orcamento?.pedidoOrcamento?.id}
						</div>
					</div>
				) : null}

				<div className="flex justify-end mt-5">
					<CustomButtonSimple className="mr-3 bg-cyan-600 hover:text-cyan-600 hover:border-cyan-600" Icon={PictureAsPdfIcon} text="Gerar PDF" onClick={() => mutation.mutate()} />

					<CustomButtonSimple Icon={EditIcon} text="Editar" onClick={() => setEditing(true)} />
				</div>
			</div>
		</>
	);
}
